import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

export default function SpiceBgEdit() {
    const history = useNavigate();

  const [file12, setFile12] = useState(null);
  const [inputVal12, setinputVal12] = useState({
    SpiceBgimg:"",
    fname12: "",
    date: "",
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setinputVal12((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res12 = await fetch(`https://pratik-agro-backend.vercel.app/getSpiceBgimg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data3 = await res12.json();

    if (res12.status === 422 || !data3) {
      console.log("error");
    } else {
      console.log(data3);
    setinputVal12({
        SpiceBgimg: data3.SpiceBgimg,
      fname12: data3.fname12,
      date: data3.date,
    });
  }
  };
  useEffect(() => {
    getData();
  }, []);

  const updateData12 = async (e) => {
    e.preventDefault();

    console.log(inputVal12);

    var formData12 = new FormData();
    if (file12 != null) {
      formData12.append("image12", file12);
    }
    formData12.append("fname12", inputVal12.fname12);
    formData12.append("date", inputVal12.date);

    for (var pair of formData12.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/updateSpiceBgimg/${id}`, formData12, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/SpiceBg");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <div className='content'>
         <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/SpiceBg">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">BackgroundImage:</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image12"
              onChange={(e) => setFile12(e.target.files[0])}
              value={inputVal12.image12}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">BackgroundImage Name: :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname12"
              onChange={setData}
              value={inputVal12.fname12}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="date"
              onChange={setData}
              value={inputVal12.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updateData12}>
              update Detail
            </Link>
          </div>
        </form>
    </div>
  )
}